import { useEffect, useState } from "react";
import { Menu, X } from "lucide-react";
import { NAV_LINKS } from "@/data/content";

export const Header = () => {
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 24);
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  const go = (href) => {
    setOpen(false);
    const el = document.querySelector(href);
    if (el) el.scrollIntoView({ behavior: "smooth" });
  };

  return (
    <header
      data-testid="site-header"
      className={`fixed top-0 left-0 right-0 z-50 transition-colors duration-500 ${
        scrolled
          ? "bg-[#faf6ef]/85 backdrop-blur-xl border-b border-[#b8965a]/25"
          : "bg-transparent border-b border-transparent"
      }`}
    >
      <div className="max-w-7xl mx-auto px-6 md:px-12 h-20 flex items-center justify-between">
        <button
          data-testid="brand-logo"
          onClick={() => window.scrollTo({ top: 0, behavior: "smooth" })}
          className="flex items-center gap-2.5 group"
        >
          <img
            src="/emblem.png"
            alt="Roam Around UAE emblem"
            className="h-11 w-auto md:h-12 transition-transform duration-300 group-hover:scale-105"
          />
          <span className="font-serif-lux text-2xl md:text-3xl tracking-tight text-[#1f3a2e] group-hover:text-[#9c7d44] transition-colors duration-300">
            roam<span className="text-[#b8965a]">around</span>uae
          </span>
        </button>

        <nav className="hidden md:flex items-center gap-10">
          {NAV_LINKS.slice(0, 3).map((link) => (
            <button
              key={link.href}
              data-testid={`nav-${link.href.replace("#", "")}`}
              onClick={() => go(link.href)}
              className="nav-link font-body-lux text-sm tracking-wide text-[#38473e] hover:text-[#1f3a2e] transition-colors duration-300"
            >
              {link.label}
            </button>
          ))}
          <button
            data-testid="header-book-btn"
            onClick={() => go("#contact")}
            className="font-body-lux text-sm tracking-wide border border-[#b8965a] text-[#9c7d44] px-6 py-2.5 hover:bg-[#b8965a] hover:text-[#fdfbf7] transition-colors duration-300"
          >
            Book Consultation
          </button>
        </nav>

        <button
          data-testid="mobile-menu-toggle"
          className="md:hidden text-[#9c7d44]"
          onClick={() => setOpen((o) => !o)}
          aria-label="Toggle menu"
        >
          {open ? <X size={26} strokeWidth={1.5} /> : <Menu size={26} strokeWidth={1.5} />}
        </button>
      </div>

      {open && (
        <div
          data-testid="mobile-menu"
          className="md:hidden bg-[#faf6ef]/97 backdrop-blur-xl border-t border-[#b8965a]/25 px-6 py-6 flex flex-col gap-5"
        >
          {NAV_LINKS.map((link) => (
            <button
              key={link.href}
              data-testid={`mobile-nav-${link.href.replace("#", "")}`}
              onClick={() => go(link.href)}
              className="font-body-lux text-left text-base text-[#38473e] hover:text-[#9c7d44] transition-colors duration-300"
            >
              {link.label}
            </button>
          ))}
        </div>
      )}
    </header>
  );
};
